<template>
  <div v-if="breadcrumbs.length > 1" class="bread-crumbs flex items-center q-pl-lg q-ml-lg">
    <template v-for="(crumb, index) in breadcrumbs" :key="index">
      <q-skeleton
        v-if="crumb.loading"
        type="text"
        width="80px"
        height="24px"
        class="breadcrumb-skeleton"
      />
      <q-btn
        v-else
        flat
        no-caps
        dense
        :color="crumb.to ? 'primary' : 'brand'"
        class="breadcrumb-item text-16"
        :class="{ 'text-font-medium': !crumb.to }"
        @click="navigateTo(crumb.to)"
      >
        <span class="breadcrumb-label ellipsis" :title="crumb.label">{{ crumb.label }}</span>
      </q-btn>
      <span v-if="index < breadcrumbs.length - 1" class="separator text-22">/</span>
    </template>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { useRoute } from 'vue-router'

import { useBreadcrumbs } from 'src/composables/app/useBreadcrumbs'
import { ROUTES } from 'src/services/consts/routes.const'

const route = useRoute()
const { breadcrumbs, navigateTo, clearBreadcrumbs } = useBreadcrumbs()

// Clear breadcrumbs when navigating to companies index
watch(
  () => route.name,
  (routeName) => {
    if (routeName === ROUTES.COMPANY || routeName === ROUTES.CREATION_REQUESTS) {
      clearBreadcrumbs()
    }
  },
)
</script>

<style lang="scss">
@import '/src/css/setup/variables.scss';

.bread-crumbs {
  border-left: 1px solid $clr-border;
  min-height: $header-height;
  flex-wrap: nowrap;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;

  .breadcrumb-item {
    min-height: unset;
    min-width: 0;
    max-width: 200px;
    flex: 0 1 auto;
    padding: 0.25rem 0.75rem;

    .q-btn__content {
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
    }
  }

  .breadcrumb-label {
    display: block;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  .separator {
    flex-shrink: 0;
    margin: 0 3px;
    color: $clr-secondary;
  }

  .breadcrumb-skeleton {
    margin: 0.25rem 0.75rem;
  }
}
</style>
